import React from 'react'
import {
  AXIS_DATE_FORMAT_OPTIONS,
  AXIS_NUMBER_FORMAT_OPTIONS,
} from '../../services/axisDisplayFormat'

function AxisFormatSelect({ label, value, onChange, options }) {
  return (
    <div className="workflow-inline-control mt-3">
      <label className="small mb-1 d-block">{label}</label>
      <select
        value={value || 'auto'}
        onChange={(event) => onChange(event.target.value)}
        className="custom-select raw-select"
      >
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default function AxisDisplayFormatControl({
  axisControls,
  visualOptions,
  setVisualOptions,
}) {
  if (!axisControls?.hasControls) return null

  const setOption = (key, nextValue) => {
    setVisualOptions((current) => ({
      ...current,
      [key]: nextValue,
    }))
  }

  return (
    <div className="workflow-inline-group">
      {axisControls.xAxis && (
        <AxisFormatSelect
          label="X-axis labels"
          value={visualOptions.xAxisDisplayFormat}
          onChange={(value) => setOption('xAxisDisplayFormat', value)}
          options={
            axisControls.xAxis.kind === 'date'
              ? AXIS_DATE_FORMAT_OPTIONS
              : AXIS_NUMBER_FORMAT_OPTIONS
          }
        />
      )}
      {axisControls.yAxis && (
        <AxisFormatSelect
          label="Y-axis labels"
          value={visualOptions.yAxisDisplayFormat}
          onChange={(value) => setOption('yAxisDisplayFormat', value)}
          options={
            axisControls.yAxis.kind === 'date'
              ? AXIS_DATE_FORMAT_OPTIONS
              : AXIS_NUMBER_FORMAT_OPTIONS
          }
        />
      )}
    </div>
  )
}
